import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        // Clear the hash from URL
        window.history.replaceState({}, document.title, window.location.pathname);
        await checkAuth();
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true, state: { error: "Google sign-in failed. Please try again." } });
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="fa-card p-8 text-center">
        <div className="font-mono text-xs uppercase tracking-widest text-slate-500 mb-2">FOIA ASSIST</div>
        <div className="text-lg">Completing sign-in…</div>
      </div>
    </div>
  );
}
